import React, { useState, useEffect, useRef } from "react";
import "../../Masterclass.css";
import Header from "../components/Header";
import Footer from "../components/Footer";
import configData from "../../config.json";
import { useNavigate } from "react-router-dom";
<link
  href="https://fonts.googleapis.com/css2?family=Poppins:wght@500;600;700&display=swap"
  rel="stylesheet"
/>

export default function MasterclassPage() {
  const [openFaq, setOpenFaq] = useState(null);
  const [countdown, setCountdown] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [showThankYou, setShowThankYou] = useState(false);
  const [step, setStep] = useState("form"); // form | otp | success
  const [userId, setUserId] = useState(null);
  const [otp, setOtp] = useState("");
  const [otpTimer, setOtpTimer] = useState(60);
  const [canResend, setCanResend] = useState(false);
  const navigate = useNavigate();

  //  Add date and time here
  const classSlots = [
    {
      label: "1 Mar 2026 – 11:00 AM",
      value: "2026-03-01|11:00:00"
    },
    {
      label: "15 Mar 2026 – 11:00 AM",
      value: "2026-03-15|11:00:00"
    }
  ];

  const now = new Date();

  const availableSlots = classSlots.filter(slot => {
    const [date, time] = slot.value.split("|");
    const slotDateTime = new Date(`${date}T${time}`);
    return slotDateTime > now;
  });


  // const openFormPopup = () => {
  //   setShowModal(true);
  // };

  const openFormPopup = () => {
    setShowThankYou(false);
    setShowModal(true);
  };

  const closeFormPopup = () => {
    setShowModal(false);
  };

  const [form, setForm] = useState({
    name: "",
    whatsapp: "",
    email: "",
    pregnancy_week: "",
    class_slot: ""
  });

  const [loading, setLoading] = useState(false);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value
    }));
  };


  const handleFormSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    if (
      !form.name ||
      !form.whatsapp ||
      !form.email ||
      !form.pregnancy_week ||
      !form.class_slot
    ) {
      alert("Please fill all fields");
      return;
    }

    try {
      setLoading(true);

      const [class_date, class_time] = form.class_slot.split("|");

      const payload = {
        full_name: form.name,
        phone: form.whatsapp,
        email: form.email,
        pregnancy_week: Number(form.pregnancy_week),
        class_date,
        class_time
      };

      const res = await fetch(
        `${configData.SERVER_API_URL}/ebookuser/insert_MasterClass_User`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );

      const data = await res.json();

      if (data.success === false) {
        if (data.code === "ER_DUP_ENTRY") {
          alert("You have already registered for this masterclass.");
        } else {
          alert(data.message || "Registration failed");
        }
        return;
      }

      const id = data.data.id;
      setUserId(id);

      await fetch(
        `${configData.SERVER_API_URL}/ebookuser/send_AI_MasterClass_Otp`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            phone: form.whatsapp,
            id: id,
            is_AI: 0
          }),
        }
      );

      setStep("otp");

    } catch (err) {
      alert("Server error. Try again.");
    } finally {
      setLoading(false);
    }
  };

  const verifyOtp = async () => {
    if (!otp) {
      alert("Enter OTP");
      return;
    }

    try {
      setLoading(true);

      const res = await fetch(
        `${configData.SERVER_API_URL}/ebookuser/verifyOtp_MasterClass`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id: userId,
            otp: Number(otp),
            is_AI: 0
          }),
        }
      );

      const data = await res.json();

      if (!res.ok || data.success === false) {
        alert("Invalid OTP");
        return;
      }

      setStep("success");
      navigate("/MasterclassThankYouPage");



    } catch {
      alert("OTP verification failed");
    } finally {
      setLoading(false);
    }
  };

  const resendOtp = async () => {
    try {
      setLoading(true);

      await fetch(
        `${configData.SERVER_API_URL}/ebookuser/send_AI_MasterClass_Otp`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            phone: form.whatsapp,
            id: userId,
            is_AI: 0
          }),
        }
      );

      // restart timer
      setOtpTimer(60);
      setCanResend(false);

    } catch {
      alert("Failed to resend OTP");
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    if (step === "otp") {
      setOtpTimer(60);
      setCanResend(false);

      const timer = setInterval(() => {
        setOtpTimer(prev => {
          if (prev <= 1) {
            clearInterval(timer);
            setCanResend(true);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      return () => clearInterval(timer);
    }
  }, [step]);


  const scrollToForm = () => {
    const formSection = document.getElementById("registration-form");
    if (formSection) {
      formSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    const end = new Date();
    end.setHours(end.getHours() + 1);

    const timer = setInterval(() => {
      const now = new Date();
      const diff = end - now;
      if (diff <= 0) return setCountdown("Offer Ended");

      const h = String(Math.floor(diff / (1000 * 60 * 60))).padStart(2, "0");
      const m = String(Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))).padStart(2, "0");
      const s = String(Math.floor((diff % (1000 * 60)) / 1000)).padStart(2, "0");

      setCountdown(`${h}:${m}:${s}`);
    }, 1000);

    return () => clearInterval(timer);
  }, []);


  return (
    <div className="page" style={{ paddingBottom: "130px" }}>
      <Header />
      <section className="hero" style={{ marginTop: "36px" }}>
        <div className="hero-grid">

          <div className="hero-content">
            <h1
              style={{
                fontFamily: "'Poppins', sans-serif",
                fontWeight: 600
              }}
            >
              Beyond ‘Everything is Normal’
            </h1>

            <h1
              style={{
                fontFamily: "'Poppins', sans-serif",
                fontWeight: 600
              }}
            >
              The 5 Hidden First-Trimester Risks Smart Working Moms Can't Ignore
            </h1>

            <p className="trust-text" style={{ color: "#4300ff", fontWeight: "bold" }}>Free 60-Minute Live Masterclass (Worth ₹999) – For Corporate, Business-Owner &
              Career-Driven Moms in their First Trimester
            </p>
            <p className="trust-text" >
              If you're juggling work, deadlines and pregnancy — this session can
              change how your baby’s development unfolds over the next 9 months.
            </p>

            <button className="primary-btn" onClick={openFormPopup}>
              Reserve My Free Seat Now
            </button>

            <span className="trust-text1" style={{ fontSize: "18px", fontWeight: "bold", color: "#ff0e9e" }}>
              Designed by senior gynecologists & expert doctors — trusted by 2000+
              working moms in our early masterclasses.
            </span>
          </div>

          <div className="hero-section">
            <div className="hero-img">
              <img src="/HeroMasterclass.png" alt="Hero" />
            </div>
          </div>
        </div>
      </section>


      <section className="why-matters">
        <div className="container why-grid">
          <div className="why-image">
            <img src="/Matter.png" alt="Why this matters" />
          </div>
          <div className="why-content">
            <h2 style={{
              fontFamily: "'Poppins', sans-serif",
            }}>Why This Matters</h2>

            <p>
              You’ve done your 12-week scan and heard “Everything looks normal.”
              <br />
              But what your reports don’t always reveal is what happens behind the scenes.
            </p>

            <p>
              The truth? Your baby’s brain development, organ growth, immune system and even
              future health could be quietly being impacted — without a single red flag on paper.
            </p>

            <p>
              You’re smart. You’re responsible. You’re doing everything right.
              Yet every working mom wonders the same thing: <span style={{ fontWeight: "bolder" }}>“Am I unknowingly risking my
                baby because of my job?”</span>

            </p>

            <p>
              That’s why we created this masterclass — designed specifically for
              high-performing, working moms like you — so you can take control
              and give your baby the strongest foundation possible.
            </p>
            <p>
              This session is designed to give you
              the clarity your doctor doesn’t have time to provide — so you can protect your baby
              without quitting your career.
            </p>
          </div>

        </div>
      </section>

      <section className="expect-section">
        <h3 className="section-title" style={{
          fontFamily: "'Poppins', sans-serif",
        }}>What You’ll Get in This 60-Minute Session</h3>

        <div className="expect-grid">
          <div className="expect-card">
            <img src="/60-Minute1.png" alt="Risks" className="card-icon" />
            <h4>5 Hidden Risks</h4>
            <p>
              The hidden risks in your first trimester that most check-ups don’t cover.
            </p>
          </div>

          <div className="expect-card">
            <img src="/60-Minute2.png" alt="Development" className="card-icon" />
            <h4>Baby’s Brain & Body</h4>
            <p>
              How stress, work pressure, diet, sleep and monitoring affect development.
            </p>
          </div>

          <div className="expect-card">
            <img src="/60-Minute3.png" alt="Framework" className="card-icon" />
            <h4>Step-by-Step Framework</h4>
            <p>
              A simple framework you can apply this week while managing your career.
            </p>
          </div>

          <div className="expect-card">
            <img src="/60-Minute4.png" alt="Expert" className="card-icon" />
            <h4>Expert Guidance</h4>
            <p>
              Insights from our expert doctor & pregnancy counsellor.
            </p>
          </div>

          <div className="expect-card">
            <img src="/60-Minute5.png" alt="Call" className="card-icon" />
            <h4>Free 1:1 Call</h4>
            <p>
              Opportunity for a personalised pregnancy counsellor call worth ₹2,500.
            </p>
          </div>
        </div>
      </section>

      <section className="who-for">
        <div className="container">
          <h2 style={{
            fontFamily: "'Poppins', sans-serif",
          }}>Who This Masterclass Is For (and Who It’s Not)</h2>

          <div className="compare-box">
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "20px",
                width: "100%"
              }}
            >
              <div
                className="box positive"
                style={{
                  flex: "1 1 30%",
                  minWidth: "300px"
                }}
              >
                <h3 style={{ fontWeight: "bolder" }}>This masterclass is ideal if you:</h3>
                <ul>
                  <li>Your time is precious — we designed this specifically for women <span style={{ fontWeight: "bolder" }}>who don’t want to waste time on low-quality advice</span></li>
                  <li>Are a working professional, founder, lawyer, CA or business owner aged 25-40, currently in your <span style={{ fontWeight: "bolder" }}>first trimester</span>.</li>
                  <li>Want structured, science-backed pregnancy care that fits your busy schedule (not another “one-size-fits-all” talk).</li>
                  <li> Are looking for practical tools and clear steps — not vague assurances — to protect your baby’s development.</li>
                  <li>Prefer to act early and proactively, rather than wait for red flags</li>
                </ul>
              </div>

              <div
                className="box negative"
                style={{
                  flex: "1 1 30%",
                  minWidth: "300px"
                }}
              >
                <h3 style={{ fontWeight: "bolder" }}>This is NOT for you if you:</h3>
                <ul>
                  <li>Women looking for YouTube-level pregnancy content.</li>
                  <li> Are looking for generic, surface-level pregnancy advice.</li>
                  <li>Are beyond your first trimester (we have other options coming).</li>
                  <li>Are not ready to take 60 minutes for your baby’s future.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="instructor">
        <div className="container">
          <h2
            style={{
              fontFamily: "'Poppins', sans-serif",
            }}>Your Instructor</h2>

          <div className="instructor-card">
            <img src="/Doctorprofile.png" alt="Doctor" />

            <div className="info">
              <h3>Dr. Aaradhya Sharma</h3>
              <p className="role">Gynaecologist & Your Pregnancy Friend</p>

              <p className="desc">
                "My goal is to make you feel so safe and heard, you forget you're talking to a doctor."
              </p>

              <ul>
                <li>11+ years of experience</li>
                <li>MBBS, DGO, MD (Obs & Gyn)</li>
                <li>Gynaecologist & Your Pregnancy Friend</li>
              </ul>
            </div>
          </div>

          <div className="instructor-card" style={{ marginTop: "30px" }}>
            <img src="/Doctorprofile.png" alt="Doctor" />

            <div className="info">
              <h3>Dr. Anuradha Tikhe</h3>
              <p className="role">Dietitian, Your Steady Hand & Reassuring Voice​</p>

              <p className="desc">
                "In all my years of practice, one thing is constant: the need for a calm, experienced hand to hold"
              </p>

              <ul>
                <li>16+ years of experience</li>
                <li>BHMS, MPH (Mumbai), Certified Pregnancy</li>
                <li>Dietitian, Your Steady Hand & Reassuring Voice​</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="offer">
        <div className="offer-inner">
          <div className="offer-image">
            <img src="/OfferSection.png" alt="Offer visual" />
          </div>

          <div className="offer-content" >
            <p style={{ paddingBottom: "10px", fontSize: "22px", color: "#5500ff", fontWeight: "bold" }}>
              Important: This session has been specially limited to only 50 seats, to ensure you
              get a chance to engage, ask questions, and walk away with a clear path.
            </p>
            <span className="strike">Regular value: ₹999</span>
            <span className="free" style={{ paddingBottom: "10px" }}>
              But for the next 2 HOURS only, you can reserve your seat free.
              Once the 50 seats are taken, the free offer will lock and the price will return to ₹999.
            </span>
            <p style={{ fontSize: "22px", fontWeight: "bold" }}>
              This is a live only session — no recording, no repeat. Miss it and you’ll miss the
              insights. Most seats fill within hours of the ad going live — don’t wait
            </p>

            <button className="primary-btn" onClick={openFormPopup}>
              Book My Free Seat Now – Only 50 Spots Left
            </button>
          </div>
        </div>
      </section>

      <section className="section light">
        <h3 className="section-title"
          style={{
            fontFamily: "'Poppins', sans-serif",
          }}>What Happens After You Register</h3>

        <div className="steps">
          <div className="step">
            <span>You’ll instantly land on a “Thank You” page with a short video message from
              Dr.Fathima , welcoming you and sharing what to expect.</span>
          </div>

          <div className="step">
            <span>You’ll feel instantly at ease once you receive the welcome WhatsApp
              message — we guide you step by step</span>
          </div>

          <div className="step">
            <span>You’ll get a WhatsApp message with your link + joining details + reminder
              messages (one day before + one hour before).</span>
          </div>

          <div className="step">
            <span>On the day, you join live, learn the high-value material, and at the end we’ll
              invite you to schedule your <span style={{ fontWeight: "bolder" }}>free 1:1 Pregnancy Counsellor Call (worth
                ₹2,500) </span>if you’re among the first 20 registrants.</span>
          </div>
        </div>
      </section>

      <section className="section faq">
        <h3 className="section-title"
          style={{
            fontFamily: "'Poppins', sans-serif",
          }}>FAQs</h3>

        {[
          {
            q: "What if I miss the live session?",
            a: "As mentioned, this masterclass will not be recorded — it’s live and limited to this batch only. If you miss it, you’ll need to register for the next batch (and value won’t be the same)."
          },
          {
            q: "Who should attend?",
            a: "Working moms in their first trimester (0-12 weeks), aged 25-40, in corporate/business/professional roles. If you’re further along, we have other solutions."
          },
          {
            q: "Is it really free?",
            a: "Yes. The usual value is ₹999, but we’re offering this free for a limited time to the first 50 registrants to join our new program batch."
          },
          {
            q: "Why is it free?",
            a: "Because this session is part of our new initiative to educate working women early in pregnancy. We believe every mom deserves clarity."
          },
          {
            q: "Do I need to buy anything?",
            a: "No purchase is required to attend. You’ll just receive the masterclass. At the end, you’ll have the option to book a free 1:1 call if you want deeper support."
          }
        ].map((item, i) => (
          <div key={i} className="faq-item">
            <button onClick={() => setOpenFaq(openFaq === i ? null : i)}>
              {item.q}
              <span>{openFaq === i ? "−" : "+"}</span>
            </button>

            {openFaq === i && <p>{item.a}</p>}
          </div>
        ))}
      </section>

      <section className="final-cta">
        <div className="final-cta-wrap">

          <div className="final-cta-img">
            <img src="/FinalCTA.png" alt="Final CTA" />
          </div>

          <div className="final-cta-content">
            <h3>
              <span style={{ fontWeight: "bolder" }}>Don’t leave this to chance</span>.
              If you’re a career-driven woman in your first trimester —
              the next 9 months matter more than you realise.
              This masterclass is your opportunity to move from uncertainty to confident control.
            </h3>

            <h3 style={{ marginTop: "10px", color: "#ff008e" }}>
              This is the most important 60 minutes you will invest
              in your baby’s early development.
            </h3>

            <h3 style={{ fontWeight: "bolder", marginTop: "10px" }}>Reserve your free seat now – only 50 spots left.</h3>

            <button className="primary-btn" onClick={openFormPopup}>
              Book My Free Seat Now
            </button>
            <p>
              *We value your privacy. Your information will be used only for sending the
              masterclass link and reminder messages.
            </p>
          </div>

        </div>
        <div
          style={{
            position: "fixed",
            bottom: 0,
            left: 0,
            width: "100%",
            background: "#ffffff",
            padding: "12px 16px 16px",
            zIndex: 9999,
            boxShadow: "0 -4px 12px rgba(0,0,0,0.12)",
            textAlign: "center"
          }}
        >

          <div
            style={{
              fontSize: "15px",
              fontWeight: "600",
              color: "#0f172a",
              marginBottom: "10px"
            }}
          >
            💥 <span style={{ fontWeight: "700" }}>Closed door</span> 60-Minute Live Masterclass
            Ends in <span style={{ color: "#ff008e", fontWeight: "700" }}>{countdown}</span>
          </div>

          <button
            onClick={openFormPopup}
            style={{
              width: "100%",
              maxWidth: "680px",
              background: "linear-gradient(90deg, #ff008e, #ff4fb8)",
              color: "#fff",
              border: "none",
              padding: "16px",
              borderRadius: "14px",
              fontSize: "18px",
              fontWeight: "700",
              cursor: "pointer",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "10px",
              margin: "0 auto"
            }}
          >
            ENROL AT
            <span
              style={{
                textDecoration: "line-through",
                opacity: 0.9,
                fontWeight: "500",
                fontWeight: "bolder"
              }}
            >
              ₹999
            </span>
            FREE
          </button>
        </div>

      </section>


      {showModal && (
        <div className="modal-overlay">
          <div className={`modal-content ${showThankYou ? "thankyou-modal" : "form-modal"}`}>
            <button className="modal-close" onClick={closeFormPopup}>
              ×
            </button>

            {step === "form" && (
              <>
                <h3 className="section-title">Reserve Your Free Seat</h3>

                <form className="registration-form" onSubmit={handleFormSubmit}>
                  <input
                    type="text"
                    name="name"
                    placeholder="Your Full Name"
                    value={form.name}
                    onChange={handleChange}
                    required
                  />

                  <input
                    type="tel"
                    name="whatsapp"
                    placeholder="Mobile Number (WhatsApp)"
                    value={form.whatsapp}
                    onChange={handleChange}
                    required
                  />

                  <input
                    type="email"
                    name="email"
                    placeholder="Email Address"
                    value={form.email}
                    onChange={handleChange}
                    required
                  />

                  <input
                    type="number"
                    name="pregnancy_week"
                    placeholder="Enter Your Current Pregnancy Week"
                    value={form.pregnancy_week}
                    onChange={handleChange}
                    required
                  />

                  <select
                    name="class_slot"
                    value={form.class_slot}
                    onChange={handleChange}
                    required
                  >
                    <option value="" disabled>
                      Choose Your Masterclass Slot
                    </option>

                    {availableSlots.map((slot, index) => (
                      <option key={index} value={slot.value}>
                        {slot.label}
                      </option>
                    ))}
                  </select>


                  <button
                    type="submit"
                    disabled={loading}
                    style={{
                      background: "#005cff",
                      color: "white",
                      border: "none",
                      padding: "14px 28px",
                      borderRadius: "40px",
                      fontSize: "16px",
                      marginTop: "30px",
                      cursor: "pointer"
                    }}
                  >
                    {/* {loading ? "Submitting..." : "Reserve My Free Seat"} */}
                    {loading ? "Sending OTP..." : "Get OTP"}
                  </button>
                </form>

                <p className="privacy-text">
                  We value your privacy. Your information will only be used to send
                  the masterclass link & reminders.
                </p>
              </>
            )}

            {step === "otp" && (
              <div style={{ textAlign: "center" }}>
                <h3>Enter OTP</h3>
                <p>We sent a 6-digit OTP to {form.whatsapp}</p>

                <input
                  type="number"
                  placeholder="Enter OTP"
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                  style={{
                    padding: "12px",
                    fontSize: "18px",
                    textAlign: "center",
                    width: "180px",
                    letterSpacing: "6px"
                  }}
                />

                <div style={{ marginTop: "12px", height: "24px" }}>
                  {!canResend ? (
                    <span style={{ color: "#777" }}>
                      Resend OTP in {otpTimer}s
                    </span>
                  ) : (
                    <button
                      onClick={resendOtp}
                      style={{
                        background: "none",
                        color: "#005cff",
                        border: "none",
                        cursor: "pointer",
                        fontWeight: "bold",
                        padding: 0
                      }}
                    >
                      Resend OTP
                    </button>
                  )}
                </div>

                <button
                  onClick={verifyOtp}
                  disabled={loading}
                  style={{
                    marginTop: "16px",
                    background: "#005cff",
                    color: "#fff",
                    padding: "12px 28px",
                    borderRadius: "30px",
                    border: "none",
                    fontSize: "16px"
                  }}
                >
                  {loading ? "Verifying..." : "Verify OTP"}
                </button>
              </div>
            )}

            {/* {step === "success" && (
       <MasterclassThankYouModal onClose={closeFormPopup} />
        )} */}
          </div>
        </div>
      )}
      <Footer />
    </div>
  );
}
